export const DEFAULT_QUESTION_TEXT = 'Question'
export const MIN_QUESTIONS_COUNT = 1
export const MAX_QUESTIONS_COUNT = 50
export const DEFAULT_QUESTION_ANSWER_COUNT = 4
